import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { CGProduct } from 'types/shopify';
import CardMaster from './CardMaster';

const useStyles: any = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        padding: theme.spacing(1, 0, 2, 0),
        [theme.breakpoints.down('md')]: {
          paddingBottom: theme.spacing(1.5),
        },
      },
      gridContainer: {
        // For mobile screens we halve the grid spacing...
        [theme.breakpoints.down('md')]: {
          marginTop: theme.spacing(-0.5),
          marginLeft: theme.spacing(-0.5),
          width: 'calc(100% + ' + theme.spacing(0.5) + ')',
          '&>.MuiGrid-item': {
            paddingTop: theme.spacing(0.5),
            paddingLeft: theme.spacing(0.5),
          },
        },
      },
      title: {
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
          paddingBottom: theme.spacing(0.5),
        },
      },
    }),
  { name: 'ProductCardGrid' },
);

const ProductCardGrid: React.FC<{
  items: CGProduct[];
  title?: string;
  productProps?: any;
  onClick?: (product: any) => void;
}> = ({ items, title, onClick, productProps = {} }) => {
  const styles = useStyles();
  return (
    <Box sx={{ flexGrow: 1 }} className={styles.root}>
      {title && (
        <Typography variant="h3" className={styles.title}>
          {title}
        </Typography>
      )}
      <Grid container className={styles.gridContainer} spacing={1}>
        {items.map((product) => (
          <Grid item xs={6} sm={4} md={3} key={product.id}>
            <CardMaster
              onClick={onClick && (() => onClick(product))}
              item={product}
              size="medium"
              // @ts-ignore
              {...productProps}
              selected={items.length > 0}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProductCardGrid;
